import { UserApiV2 } from 'ha/services/apiV2/types/User';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

const googleLogin = (makeCall: MakeCall) => (code: string) =>
  makeCall<UserApiV2>('POST', `${APIV2_URL}/action/google-login`, {
    data: { code },
  });

export default googleLogin;
